"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRLogin = exports.rskRpcUrls = exports.rskTestnetRpcUrl = exports.rskMainnetRpcUrl = void 0;
var rlogin_1 = __importDefault(require("@rsksmart/rlogin"));
var web3_provider_1 = __importDefault(require("@walletconnect/web3-provider"));
var web3_1 = __importDefault(require("@portis/web3"));
var rlogin_trezor_provider_1 = require("@rsksmart/rlogin-trezor-provider");
var rlogin_ledger_provider_1 = require("@rsksmart/rlogin-ledger-provider");
var rlogin_dcent_provider_1 = require("@rsksmart/rlogin-dcent-provider");
exports.rskMainnetRpcUrl = {
    30: 'https://public-node.rsk.co'
};
exports.rskTestnetRpcUrl = {
    31: 'https://public-node.testnet.rsk.co'
};
exports.rskRpcUrls = Object.assign({}, exports.rskMainnetRpcUrl, exports.rskTestnetRpcUrl);
var defaultTrezorOptions = {
    manifestEmail: 'info@iovlabs.org',
    manifestAppUrl: 'https://rifos.org'
};
var createRLogin = function (rpcUrls, rloginOptions) {
    if (rpcUrls === void 0) { rpcUrls = exports.rskRpcUrls; }
    var providerOptions = Object.assign({
        walletconnect: {
            package: web3_provider_1.default,
            options: {
                rpc: rpcUrls,
                bridge: 'https://walletconnect-bridge.rifos.org/'
            }
        },
        'custom-ledger': rlogin_ledger_provider_1.ledgerProviderOptions,
        'custom-dcent': rlogin_dcent_provider_1.dcentProviderOptions,
        'custom-trezor': __assign(__assign({}, rlogin_trezor_provider_1.trezorProviderOptions), { options: (rloginOptions === null || rloginOptions === void 0 ? void 0 : rloginOptions.trezor) || defaultTrezorOptions })
    }, rpcUrls[31]
        ? {
            portis: {
                package: web3_1.default,
                options: {
                    id: (rloginOptions === null || rloginOptions === void 0 ? void 0 : rloginOptions.portis) || '',
                    network: {
                        nodeUrl: rpcUrls[31],
                        chainId: 31
                    }
                }
            }
        }
        : {});
    var supportedChains = Object.keys(rpcUrls).map(Number);
    return new rlogin_1.default(({
        cacheProvider: false,
        providerOptions: providerOptions,
        rpcUrls: rpcUrls,
        supportedChains: supportedChains
    }));
};
exports.createRLogin = createRLogin;
